module.exports = __webpack_public_path__ + "img/Motor_mob_3.9e4934ed.jpg";